import { h } from 'preact';
import { formatNumber, getAnnual } from '../../lib/util';
import style from './style';
import cx from 'classnames';
import { Text } from 'preact-i18n';
import localtime from '@os/localtime';


export default function StockDataTable ({ data, cols, compact = false, showDates, timespan = 'quarterly', ...props }) {
	let dates = [],
		rows = data && data.rows;

	if (timespan === 'quarterly') {
		rows = rows.slice(0, 4);
	}
	else {
		rows = getAnnual(rows);
	}

	if (showDates) {
		let rd = data.columns.indexOf('Reported Date');

		dates = rows.map( (row, i) => {
			if (timespan === 'quarterly') {
				let cq = data.columns.indexOf('Calendar Quarter');
				let yearSuffix = localtime.format('%y')(new Date(row[rd]));
				let quarter = row[cq] && row[cq][1] || '';
				return <Text id="format.date.quarterDate" fields={{ yearSuffix, quarter }} />;
			}

			let [year, month, day] = row[rd].split('-');
			return <Text id="format.date.numberDate" fields={{ month, day, year }} />;
		});
	}
	else {
		dates = rows.map( (row) => '\u00A0' );
	}

	props.title = showDates && !props.title ? '\u00A0' : props.title;

	return (
		<table class={cx(style.financeTable, style[timespan])}>
			<thead>
				<tr>
					{ props.title && <th>{props.title}</th> }
					{ dates.map( (date, i) => (
						<th>{date}</th>
					)) }
				</tr>
			</thead>
			<tbody>
				{
					cols.map( (obj) => (
						<tr>
							<td class={cx(obj.bold && style.bold)}>
								{ obj.nameIntl || obj.name }{obj.sup && <sup>{obj.sup}</sup>}
							</td>
							{
								rows.map( (row) => {
									let val = row[data.columns.indexOf(obj.name)];
									return (
										<td class={cx(obj.bold && style.bold, val < 0 && style.negative)}>
											{ formatNumber(val, { Compact: compact, inThousands: true, Comma: true, Default: '-' }) }
										</td>
									);
								})
							}
						</tr>
					))
				}
			</tbody>
		</table>
	);
}
